const throttle = (func, waitMS) => {
    let timeout = null;
    let that;
    let _args = null;
    const throttled = function (...args) {
        if (timeout !== null) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            that = this;
            _args = args;
            return;
        }
        func.apply(this, args);
        timeout = setTimeout(() => {
            timeout = null;
            if (_args !== null) {
                func.apply(that, _args);
                _args = null;
            }
        }, waitMS);
    };
    throttled.cancel = () => {
        if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
            _args = null;
        }
    };
    return throttled;
};

export { throttle };
//# sourceMappingURL=throttle.js.map
